export default {
  computed: {
    visibilidade_carrinho_compra: {
      get: function () {
        return this.$store.getters["carrinhoDepartamentos/getAtivo"]
      },
      set: function (value) {
        return this.$store.dispatch("carrinhoDepartamentos/mudarVisibilidadeCarrinho", value)
      }
    }
  }
}
